import {getLocalMeta,setLocalMeta} from './database.js';

const usageKey=(userId)=> `bookmark-usage:${userId}`;
let writeChain=Promise.resolve();

const cleanUsage=(value)=> value && typeof value==='object' && !Array.isArray(value) ? value : {};

export const getBookmarkUsage=async (userId)=> {
  if (!userId) return {};
  return cleanUsage(await getLocalMeta(usageKey(userId)));
};

export const recordBookmarkOpen=(userId,bookmarkId)=> {
  if (!userId || !bookmarkId) return Promise.resolve({});
  writeChain=writeChain.then(async ()=> {
    const usage=await getBookmarkUsage(userId);
    const previous=usage[bookmarkId] || {count:0,lastOpenedAt:0};
    const next={
      ...usage,
      [bookmarkId]:{
        count:Math.max(0,Number(previous.count) || 0)+1,
        lastOpenedAt:Date.now()
      }
    };

    const entries=Object.entries(next);
    if (entries.length>750) {
      entries
        .sort(([,a],[,b])=> (Number(b.lastOpenedAt) || 0)-(Number(a.lastOpenedAt) || 0))
        .slice(750)
        .forEach(([id])=> delete next[id]);
    }

    await setLocalMeta(usageKey(userId),next);
    if (typeof window!=='undefined') {
      window.dispatchEvent(new CustomEvent('bmp:bookmark-usage',{detail:{userId,usage:next}}));
    }
    return next;
  }).catch(error=> {
    console.warn('Unable to record bookmark usage:',error);
    return {};
  });
  return writeChain;
};

export const rankFrequentlyUsed=(bookmarks,usage,limit=8)=> {
  const now=Date.now();
  return (bookmarks || [])
    .map(bookmark=> {
      const stats=usage?.[bookmark.id];
      if (!stats?.count) return null;
      const count=Math.max(1,Number(stats.count) || 1);
      const lastOpenedAt=Number(stats.lastOpenedAt) || 0;
      const ageDays=lastOpenedAt ? Math.max(0,(now-lastOpenedAt)/(24*60*60*1000)) : 365;
      const recencyBoost=Math.max(0,14-ageDays)/14*2;
      const score=Math.log2(count+1)*3+recencyBoost;
      return {...bookmark,_usageCount:count,_lastOpenedAt:lastOpenedAt,_usageScore:score};
    })
    .filter(Boolean)
    .sort((a,b)=> b._usageScore-a._usageScore || b._lastOpenedAt-a._lastOpenedAt || String(a.title || '').localeCompare(String(b.title || '')))
    .slice(0,Math.max(1,limit));
};